import "./styles/App.css";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();

  const handleAboutClick = () => {
    navigate("/about");
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`headerDiv ${scrolled ? "scrolled" : ""}`}>
      <Helmet>
        <meta
          name="description"
          content="Tražite savršen apartman na Zlatiboru? Apartman Stari Vlah nudi udoban i povoljan smeštaj u srcu Zlatibora. Rezervišite sada i uživajte u prirodi!"
        />
        <meta
          name="keywords"
          content="smeštaj Zlatibor, apartman Zlatibor, povoljan smeštaj Zlatibor, jeftin smeštaj Zlatibor, Zlatibor apartmani, apartmani na Zlatiboru, Zlatibor smeštaj centar, planinski apartmani Zlatibor, privatni smeštaj Zlatibor, najpovoljniji apartmani Zlatibor, smeštaj blizu centra Zlatibor, Zlatibor izdavanje apartmana, Stari Vlah Zlatibor, apartman sa parkingom Zlatibor, luksuzan apartman Zlatibor, apartman za dvoje Zlatibor, apartman za porodicu Zlatibor"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "Apartman Stari Vlah Zlatibor",
            image: "/images/logoKvadratBezPozadine.webp",
            "@id": "https://starivlahzlatibor.com/",
            url: "https://starivlahzlatibor.com/",
            telephone: "+381612423547",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Nikole Altomanovica 6",
              addressLocality: "Zlatibor",
              addressRegion: "Serbia",
              postalCode: "31315",
              addressCountry: "RS",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: "43.679",
              longitude: "19.593",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "00:00",
              closes: "23:59",
            },
            priceRange: "25$-35$",
          })}
        </script>
      </Helmet>
      <a
        href="/"
        style={{ height: "fit-content", paddingTop: "1vh" }}
        rel="noopener noreferrer"
        title="Početna stranica - Apartman Stari Vlah Zlatibor"
      >
        <motion.img
          src="/images/logoKvadratBezPozadine.webp"
          className="headerLogo"
          alt="Apartman Stari Vlah Zlatibor Smestaj - Logo"
          loading="eager"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        ></motion.img>
      </a>
      <motion.label
        className="burger"
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
      >
        <input
          type="checkbox"
          id="burger"
          onChange={toggleMenu}
          checked={isMenuOpen}
          aria-label="Otvori ili zatvori meni"
        />
        <span></span>
        <span></span>
        <span></span>
      </motion.label>

      <div
        className={`overlay ${isMenuOpen ? "show" : ""}`}
        onClick={toggleMenu}
      ></div>

      <nav
        className={`nav-links ${isMenuOpen ? "open" : ""} ${
          scrolled ? "scrolled" : ""
        }`}
      >
        <ul className="navigationList">
          <a
            href="/"
            className="listHref"
            rel="noopener noreferrer"
            title="Početna stranica - Apartman Stari Vlah Zlatibor"
          >
            <motion.li
              className="navigationListItem"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 }}
            >
              <span className="headerSpan">
                <img
                  className="navigationIcon"
                  src="/images/cabin.png"
                  alt="Početna stranica - Apartman Stari Vlah Zlatibor"
                  loading="lazy"
                />
                <p className="navigationOptions">Početna</p>
              </span>
            </motion.li>
          </a>
          <a
            href="/booking"
            className="listHref"
            rel="noopener noreferrer"
            title="Rezreviši smeštaj - Apartman Stari Vlah Zlatibor"
          >
            <motion.li
              className="navigationListItem"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            >
              <span className="headerSpan">
                <img
                  className="navigationIcon"
                  src="/images/booking2.webp"
                  alt="Rezervišite Apartman Stari Vlah Zlatibor"
                  loading="lazy"
                />
                <p
                  className="navigationOptions"
                  style={{ color: "#c55a11", fontWeight: "700" }}
                >
                  Rezerviši
                </p>
              </span>
            </motion.li>
          </a>
          <a
            href="/gallery"
            className="listHref"
            rel="noopener noreferrer"
            title="Galerija slika - Apartman Stari Vlah Zlatibor"
          >
            <motion.li
              className="navigationListItem"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
            >
              <span className="headerSpan">
                <img
                  className="navigationIcon"
                  src="/images/gallery.png"
                  alt="Galerija - Apartman Stari Vlah Zlatibor"
                  loading="lazy"
                />
                <p className="navigationOptions">Galerija</p>
              </span>
            </motion.li>
          </a>

          <div
            style={{ borderRadius: "1vh" }}
            onClick={handleAboutClick}
            className="listHref"
            rel="noopener noreferrer"
            title="O nama - Apartman Stari Vlah Zlatibor"
            onMouseEnter={!isMobile ? () => setIsDropdownOpen(true) : undefined}
            onMouseLeave={
              !isMobile ? () => setIsDropdownOpen(false) : undefined
            }
          >
            <motion.li
              className="navigationListItem"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
            >
              <span className="headerSpan" style={{ paddingBottom: "0" }}>
                <img
                  className="navigationIcon"
                  src="/images/pinetree.png"
                  alt="O nama - Apartman Stari Vlah Zlatibor"
                  loading="lazy"
                />
                <p className="navigationOptions">O nama</p>

                <img
                  className="downArrowImg"
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setIsDropdownOpen(!isDropdownOpen);
                  }}
                  src={
                    isDropdownOpen
                      ? "/images/upArrow.webp"
                      : "/images/downArrow.webp"
                  }
                  alt="Apartman Stari Vlah Zlatibor Ikona"
                />
              </span>
            </motion.li>
            {isDropdownOpen && (
              <ul className="dropDownAboutMenu">
                <li
                  className="dropDownAboutList"
                  style={{ borderTop: "1px solid #f5e3c34e" }}
                >
                  <img className="aboutListIcon"  src={isMobile ? "/images/question.webp" : "/images/question_pc.webp"} />
                  <a href="/questions" className="dropDownAboutLink">
                    Česta pitanja
                  </a>
                </li>
                <li className="dropDownAboutList">
                  <img className="aboutListIcon"  src={isMobile ? "/images/review.webp" : "/images/review_pc.webp"} />
                  <a href="/reviews" className="dropDownAboutLink">
                    Recenzije
                  </a>
                </li>
              </ul>
            )}
          </div>

          <a
            href="/contact"
            className="listHref"
            rel="noopener noreferrer"
            title="kontakt - Apartman Stari Vlah Zlatibor"
          >
            <motion.li
              className="navigationListItem"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
            >
              <span className="headerSpan">
                <img
                  className="navigationIcon"
                  src="/images/contact.png"
                  alt="Kontakt - Apartman Stari Vlah Zlatibor"
                  loading="lazy"
                />
                <p className="navigationOptions">Kontakt</p>
              </span>
            </motion.li>
          </a>
          <a
            href="/blog"
            className="listHref"
            rel="noopener noreferrer"
            title="Blog - Apartman Stari Vlah Zlatibor"
          >
            <motion.li
              className="navigationListItem"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.6 }}
            >
              <span className="headerSpan">
              <img
                className="navigationIcon"
                src="/images/blog.png"
                alt="Blog o Zlatiboru - Apartman Stari Vlah"
                loading="lazy"
              />
              <p className="navigationOptions">Blog</p>
              </span>
              
            </motion.li>
          </a>
        </ul>
      </nav>
    </div>
  );
}

export default Header;
